import axios from 'axios';
import { apiUrl } from './baseUrls';

const instance = axios.create({
  baseURL: apiUrl,
  withCredentials: true
});

export default instance;
